import React from 'react';
import Icon, { NAMES } from '@ifit/react-icons';
import Loading from '@ifit/mary-poppins/dist/Loading';

import iFitLogo from './img/ifit-logo.svg';

import './index.scss';

const ifitBlue12 = `rgba(23, 149, 210, 0.12)`;

export default () => (
  <section className="pf-connecting">
    <div className="images">
      <img
        src={ iFitLogo }
        className="ifit-logo"
        alt="iFit Logo"
      />
      <Icon
        className="ifit-more-mark"
        name={ NAMES.IFIT_MORE_FILLED }
        color={ ifitBlue12 }
      />
    </div>
    <div className="status">
      <Loading />
      <p>Logging you in...</p>
    </div>
  </section>
);